"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../utils/constants");
var muiHouseFill16 = {
    paths: [
        {
            path: 'M2.00167186,6 L1.00167186,6 C-0.0237909234,6 -0.384818108,4.64052887 0.505532921,4.13175686 L7.50553292,0.131756858 C7.81296559,-0.0439189526 8.19037813,-0.0439189526 8.4978108,0.131756858 L12.0016719,2.13396318 L12.0016719,1 C12.0016719,0.44771525 12.4493871,0 13.0016719,0 C13.5539566,0 14.0016719,0.44771525 14.0016719,1 L14.0016719,3 C14.0016719,3.08909161 13.9900212,3.17546207 13.9681604,3.25767093 L15.4978108,4.13175686 C16.3881618,4.64052887 16.0271346,6 15.0016719,6 L14.0016719,6 L14.0016719,13 C14.0016719,13.5522847 13.5539566,14 13.0016719,14 L11.0016719,14 C10.4493871,14 10.0016719,13.5522847 10.0016719,13 L10.0016719,10 C10.0016719,9.44771525 9.55395661,9 9.00167186,9 L7.00167186,9 C6.44938711,9 6.00167186,9.44771525 6.00167186,10 L6.00167186,13 C6.00167186,13.5522847 5.55395661,14 5.00167186,14 L3.00167186,14 C2.44938711,14 2.00167186,13.5522847 2.00167186,13 L2.00167186,6 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'House',
    width: 16,
    height: 14,
};
var muiHouseFill24 = {
    paths: [
        {
            path: 'M18,3.63172948 L12.5386713,0.156338512 C12.2111049,-0.0521128374 11.7924868,-0.0521128374 11.4649204,0.156338512 L0.464920356,7.15633851 C-0.379118644,7.69345424 0.00134837955,9 1.00179585,9 L23.0017958,9 C24.0022433,9 24.3827103,7.69345424 23.5386713,7.15633851 L22,6.17718402 L22,1.68736402 C22,1.13507927 21.5522847,0.687364024 21,0.687364024 L19,0.687364024 C18.4477153,0.687364024 18,1.13507927 18,1.68736402 L18,3.63172948 L18,3.63172948 Z M2,9 L22,9 L22,23 C22,23.5522847 21.5522847,24 21,24 L16,24 C15.4477153,24 15,23.5522847 15,23 L15,18 C15,17.4477153 14.5522847,17 14,17 L10,17 C9.44771525,17 9,17.4477153 9,18 L9,23 C9,23.5522847 8.55228475,24 8,24 L3,24 C2.44771525,24 2,23.5522847 2,23 L2,9 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'House',
    width: 24,
    height: 24,
};
var muiHouseFill = {
    base: muiHouseFill16,
    smIcon: muiHouseFill16,
    lgIcon: muiHouseFill24,
};
exports.muiHouseFill = muiHouseFill;
//# sourceMappingURL=houseFill.js.map